app.controller('loginController', ['$scope', '$rootScope', '$state', '$cookies', '$timeout', 'objectHelper', 'applicationModel', 'authModel', 'userModel', '$translate',
    function ($scope, $rootScope, $state, $cookies, $timeout, objectHelper, applicationModel, authModel, userModel, $translate) {

        function setData() {
            $scope.loginData = new LoginVO();
            $scope.authenticationError = false;

            $scope.selectedLanguage = $translate.use();
            if($scope.selectedLanguage === 'de_DE') {
                $scope.ueImage = 'UE_DE.jpg';
                $scope.rulesURL = 'http://www.emrplus.de/serviceordnung/';
            } else {
                $scope.ueImage = 'UE_PL.jpg';
                $scope.rulesURL = 'http://www.edmplus.pl/regulamin-serwisu-edmplus/';
            }

            $scope.forms = {
                loginForm: null
            }
        }

        function setPermissions() {
        }

        function setListeners() {
            $scope.$on('$destroy', function (event) {
                applicationModel.viewReady = false;
            });

            $scope.$on(Event.AUTH.AUTHENTICATE.ERROR, function (event, error) {
                $scope.authenticationError = true;
            });
        }

        function setActions() {
            $scope.login = function() {
                userModel.selectedLanguage = $scope.selectedLanguage;
                localStorage.setItem('edm_lang', $scope.selectedLanguage);
                $cookies.put('lang', $scope.selectedLanguage);
                $scope.forms.loginForm.$setSubmitted();

                if ($scope.forms.loginForm.$valid) {
                    authModel.authenticate($scope.loginData.username, $scope.loginData.password);
                }
                else {
                    $scope.notifyValidationError();
                }
            };

            $scope.goToRegistration = function() {
                $state.go(Constant.STATE.PRE.REGISTRATION.PERSONAL_DATA);
            };

            $scope.languageChanged = function () {
                $translate.use($scope.selectedLanguage);
                if($scope.selectedLanguage === 'de_DE') {
                    $scope.ueImage = 'UE_DE.jpg';
                    $scope.rulesURL = 'http://www.emrplus.de/serviceordnung/';
                } else {
                    $scope.ueImage = 'UE_PL.jpg';
                    $scope.rulesURL = 'http://www.edmplus.pl/regulamin-serwisu-edmplus/';
                }
            };
        }

        function configureInterface() {
        }

        function initialize() {
            applicationModel.viewReady = true;
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
